<template>
    <div class="md-detail-info fashion" :style="{ marginBottom }">
        <DetailBanner
            :listingDetail="listingDetail"
            :scheduleInfo="scheduleInfo"
            :apptTitle="apptTitle"
            :apptSubTitle="apptSubTitle"
            :apptSubmitText="apptSubmitText"
            :apptQuestionMsg="apptQuestionMsg"
            @showFixedBannerChange="showFixedBannerChange"
        ></DetailBanner>
        <DetailInfo
            ref="detailInfo"
            :scheduleInfo="scheduleInfo"
            :positionProvided="positionProvided"
            :showFixedBanner="showFixedBanner"
            :apptTitle="apptTitle"
            :apptSubTitle="apptSubTitle"
            :apptSubmitText="apptSubmitText"
            :apptQuestionMsg="apptQuestionMsg"
        ></DetailInfo>
        <BottomMenu
            ref="mobileBottomMenu"
            theme="fashion"
            v-if="isMobileSize"
        ></BottomMenu>
        <house-mask v-if="isShowMask" theme="fashion" />
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </div>
</template>

<script>
import Common from '../index';
import DetailInfo from './detail-info.vue';
import DetailBanner from './banner.vue';
import BottomMenu from '../bottom-menu.vue';
import HouseMask from '../mask.vue';
export default {
    components: {
        DetailInfo,
        DetailBanner,
        BottomMenu,
        HouseMask
    },
    mixins: [Common],
    data: function() {
        return {
            scheduleInfo: {},
            shareMode: 'fixed',
            leaveMsgTheme: 'template4',
            showFixedBanner: false,
            theme: 'fashion',
            styleTheme: 'fashion'
        };
    },
    computed: {
        _baseTheme() {
            return 'fashion';
        }
    },
    provide() {
        return {
            sharePop: this.sharePop,
        };
    },

    methods: {
        showFixedBannerChange(v) {
            this.showFixedBanner = v;
        },
        scrollIntoSchedule() {
            if (this.$refs.detailInfo.$refs.schedule) {
                this.$refs.detailInfo.$refs.schedule.$el.scrollIntoView();
            }
        },
        changeShowFixedBanner(v) {
            this.showFixedBanner = v;
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
$right-width: 320px;
.md-detail-info.fashion {
    position: relative;
    .mg-container:not(.breadcrumb-bar) {
        position: relative;
        overflow: visible;
        &:after {
            content: '';
            display: block;
            clear: both;
        }
    }
}
</style>
